import _ from 'lodash'
import React, { Component } from 'react'
import {  Col, FormGroup , Popover, OverlayTrigger } from "react-bootstrap";
import {  Field, reduxForm, propTypes,formValueSelector } from 'redux-form'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { PropTypes } from 'prop-types'
import { saveEventSetup,setHasBrackets } from "../../../../redux/actions/action_event"
//import { onlypositivenumbers } from '../../../../utils/helperfunctions/onlypositivenumbers'
import {  videoblue, warning, red, gray,forms } from "../../../../utils/constants"
import  fields  from './fields'
import '../../../../utils/css/nospinner.css'

const FormName = forms.eventinfo

class EventSetup extends Component {
	static propTypes = {
		...propTypes
	}
	constructor (props) {
		super(props)
		this.state = {
			showNumberGamesError:false
		}
		this.minNumberGames                = this.minNumberGames.bind(this)
		this.handleCheckMinNumberGames     = this.handleCheckMinNumberGames.bind(this)
		this.showMinNumberGamesNotMetError = this.showMinNumberGamesNotMetError.bind(this)
		this.checkMinNumberGames           = this.checkMinNumberGames.bind(this)
		this.isSetupEqual                  = this.isSetupEqual.bind(this)
		this.handleOnKeyPress 						 = this.handleOnKeyPress.bind(this)
		this.handleHasBracket              = this.handleHasBracket.bind(this)
	}
    
  //#region Lifecycle methods
	componentDidMount() {
		this.checkMinNumberGames()
		window.scrollTo(0, 0)
	}
	componentWillUnmount() {
		const { eventId,standardgames,bakergames,prestinesetup,hasbrackets } = this.props
		const { isSetupEqual } = this
		const saveInfo   = !isSetupEqual(prestinesetup,this.props)

		if(saveInfo) {
			const details = {
				eventId:eventId,
				step:4,
				numberOfBakerGames:bakergames != null ? bakergames:0,
				numberOfStandardGames:standardgames != null ? standardgames:0,
				hasBrackets:hasbrackets 
			}
		
			saveEventSetup(details)
		}
	}
	//#endregion lifecycle methods
	
	//#region  Section event handlers
	handleCheckMinNumberGames(event) {
		const { standardgames, bakergames } = this.props
		const { name, value }   = event.target
		let standard = standardgames
		let baker    = bakergames

		const isANumber = !isNaN(value)
	
		if ( name == fields.BAKERGAMES ) {
				if (isANumber) {
						baker = value
				}
				standard = standardgames
		}
		else if ( name == fields.STANDARDGAMES ) {
				if (isANumber ){
						standard = value
				}
				baker = bakergames
		} 
		this.warnMinGamesNotMet(standard, baker)
	}
  //#endregion Event handlers
	//#region Supporting functions
	handleOnKeyPress(evt)
	{
		if (evt.which != 8 && evt.which != 0 && evt.which < 48 || evt.which > 57)
		{
			evt.preventDefault()
		}
	}
	handleHasBracket(event)
	{
		const { dispatch } = this.props
		const hasBrackets = event.target.value == 'true'? true:false
		dispatch(setHasBrackets(hasBrackets))
	}
	minNumberGames() {
			// returns the min number of games in a tournament based on tier and season settings
			const { eventtier,eventSeasonSettings } = this.props
			if(eventSeasonSettings) {
				const { minT1games, minT2games } = eventSeasonSettings
				return (eventtier == '2') ? minT2games:minT1games
			}
			else {
				return 1
			}
	} 
	warnMinGamesNotMet (standard, baker)
	{	
		console.log('warnMinGamesNotMet')
		const { eventSeasonSettings } = this.props
		if (eventSeasonSettings != undefined) 
		{
			const { bakerToStandardGamesRatio } = eventSeasonSettings
			const ratio = bakerToStandardGamesRatio ? bakerToStandardGamesRatio:5
			const minNumberGames = this.minNumberGames()

			baker = typeof(parseInt(baker)) == 'number' ? parseInt(baker):0
			standard = typeof(parseInt(standard)) == 'number' ? parseInt(standard):0
		
			if (isNaN(standard)) {
					standard = 0
			}
			if (isNaN(baker)) {
					baker = 0
			}
			const numGames = standard + ( baker / ratio )
			console.log('numgames',numGames,minNumberGames)
			if ( numGames < minNumberGames ) {
				this.showMinNumberGamesNotMetError(true)
			}
			else {
				this.showMinNumberGamesNotMetError(false)
			}
		}
	}
	checkMinNumberGames() {
		const { standardgames, bakergames } = this.props
		this.warnMinGamesNotMet(standardgames, bakergames)
	}
	showMinNumberGamesNotMetError(show) {
		const { showNumberGamesError } = this.state
		if (show) {
			if ( !showNumberGamesError ) {
				this.setState({ showNumberGamesError:true })
			}
		}
		else  {
			if ( showNumberGamesError ) {
				this.setState({ showNumberGamesError:false })
			}
		}
	}
	isSetupEqual (original,current) {
		let equal = true

		if((original != undefined) && (current != undefined))
		{
			if (original.standardgames != current.standardgames) {
				equal = false
			}
			if (original.bakergames != current.bakergames) {
				equal = false
			}
			if (original.hasbrackets != current.hasbrackets) {
				equal = false
			}
		}
		else {
			equal = false
		}
	
		return equal		
	}
  //#endregion Supporting functions
	render()
	{
			const { showNumberGamesError } = this.state
			const lblattrs = 'col-sm-3 control-label';
			const graybox=gray
			const popoverRight = (
				<Popover  id='poright' title='Warning!!' style={{ color:'rgb(255,144,43)',minWidth:'470px' }}>
					<em className="fa fa-exclamation-triangle" 
						style={{ color:'rgb(255,144,43)' }} 
					/>&nbsp;&nbsp;
					<span style={{ color:'black' }}>
						Bracket and non-standard formats are not supported for uploading, but must be emailed to <span style={{ color:'blue' }}>USBCcollegiate@ibcyouth.com</span>. Submit brackets as a .pdf file for posting results as an excel file.
					</span>
				</Popover>
			)

			const { handleSubmit, previousPage,eventname ,eventSeasonSettings,hasbrackets } = this.props   

			return (
					<div style={{ marginTop:'1%' }} sm={12} md={12} lg={12}>
							<form className="form-horizontal" onSubmit={handleSubmit}  sm={6} md={10} lg={12} style={{ padding:'0' }} >
									<Col lg={12} md={12} style={{ border:`1px solid ${graybox}`,padding:'10px 0 0 0' , marginBottom:'10px' }}> 
										<FormGroup style={{ paddingLeft:'15px', paddingBottom:'0', marginBottom:'0' }}>
											<h4 className='col-sm-12 col-md-12 col-lg-7' style={{ color:videoblue }}>{' '}Setup - <span style={{ color:'green' }}>{_.startCase(_.toLower(eventname))}</span>  </h4>
										</FormGroup>

										{ eventSeasonSettings &&
											(<span xs={6} style={{ color:warning, paddingLeft:'15px' }}>*Minimum number of games is {this.minNumberGames()}. Baker to standard games ratio is { eventSeasonSettings.bakerToStandardGamesRatio} to 1.</span>)
										}
										{ showNumberGamesError &&
											(
												<div style={{ marginTop:'15px', color:red, paddingLeft:'5%',fontWeight:'bold' }}> 
													<i className="fa fa-exclamation-triangle" aria-hidden="true" />{'  '}<span>Total number of games does not meet minimum requirements for ranking points.</span>
												</div>
											)
										}
											<FormGroup style={{ marginTop:'20px' }}>
												<label className={lblattrs}>Number of standard games</label>
												<Field
													type='number'
													name={ fields.STANDARDGAMES }
													component='input'
													className="form-control no-spinners"
													style={{ maxWidth: '70px' }}
													max = {99}  
													onChange={ this.handleCheckMinNumberGames }    
													onKeyPress={ this.handleOnKeyPress }                                   
												/>
											</FormGroup>
											<FormGroup>
												<label className={lblattrs}>Number of baker games</label>
												<Field
													type='number'
													name={ fields.BAKERGAMES }
													component='input'
													className="form-control no-spinners"
													style={{ maxWidth: '70px' }}
													max = {99}  
													onChange={this.handleCheckMinNumberGames} 
													onKeyPress={this.handleOnKeyPress}                                   
												/>
											</FormGroup>
											<FormGroup>
												<label className={lblattrs}>Is there a bracket? </label>
												<Col sm={6 } md={6} lg={7}>
													<label className="radio-inline c-radio">
													<OverlayTrigger trigger='click' placement='right' overlay={popoverRight} rootClose  style={{ minWidth:'350px' }}>
														<input id="jvyes" type="radio" name="validinfo" value defaultChecked={hasbrackets} onChange={this.handleHasBracket}  />
													</OverlayTrigger>
													<em className="fa fa-circle" />&nbsp;&nbsp;Yes
													</label>
													<label className="radio-inline c-radio"  >
														<input id="jvno" type="radio" name="validinfo"  value={false} defaultChecked={!hasbrackets} onChange={this.handleHasBracket} />
														<em className="fa fa-circle" style={{ color:'rgb(255,144,43)' }} onChange={this.handleInvalidInfo}  />&nbsp;&nbsp;No 
													</label>    
												</Col>
											</FormGroup>
									</Col>
									<Col sm={12} md={12} lg={12} > 
											<button type="button" className="btn btn-primary pull-left previous" onClick={previousPage} style={{  fontSize:'120%',fontWeight:'bold'  }}>
												<i className="fa fa-caret-left" aria-hidden="true"  />&nbsp;&nbsp;Previous
											</button>
											<button type="submit" className="btn btn-primary pull-right next" style={{ minWidth:'120px', fontSize:'120%',fontWeight:'bold'  }}>
												<i className='fa fa-caret-right' aria-hidden="true"  />&nbsp;&nbsp; Next
											</button>  
									</Col>        
							</form>
					</div>)
	}
}

function mapStateToProps(state,ownProps){ 
	const formName =  ownProps.form
	const selector = formValueSelector(formName)
	const eventId             = selector(state,'eventId')
	const standardgames       = selector(state,fields.STANDARDGAMES)
	const bakergames          = selector(state,fields.BAKERGAMES)
	const eventname           = selector(state,'eventname')
	const hasbrackets           = selector(state,'hasbrackets')
	const eventtier           = selector(state,'eventtier')
	const eventSeasonSettings = selector(state,'eventSeasonSettings')
	const prestinesetup       = selector(state,'prestinesetup')
	return {
		eventId,
		eventname,
		eventtier,
		standardgames,
		hasbrackets,
		bakergames,
		eventSeasonSettings,
		prestinesetup
	}
}  
function mapDispatchToProps(dispatch){
	return bindActionCreators({
		saveEventSetup,
		setHasBrackets
	},dispatch)
}

EventSetup.propTypes = {
	handleSubmit:PropTypes.func,
	previousPage:PropTypes.func,
	dispatch:PropTypes.func,
	eventId:PropTypes.number,
	saveEventSetup: PropTypes.func,
	eventname:PropTypes.string,
	standardgames:PropTypes.number,
	bakergames: PropTypes.number,
	eventSeasonSettings:PropTypes.object,
	eventtier:PropTypes.string,
	prestinesetup:PropTypes.object,
	hasbrackets:PropTypes.bool,
	setHasBrackets:PropTypes.func
}

function validate() {   
	const errors = {}
	return errors
}

export default reduxForm({
	validate,
	form:FormName,
	destroyOnUnmount: false,
	forceUnregisterOnUnmount: false
})(connect(mapStateToProps,mapDispatchToProps)(EventSetup))


// WEBPACK FOOTER //
// ./src/containers/event/EventWizard/Setup/index.js